// @flow
import React from 'react';
import { Field } from 'formik';
import { Flex } from '@rebass/grid';
import FieldLabel from './FieldLabel';
import TextInput from './TextInput';
import FormikTree from './FormikTree';

import {
  FormikTwitter,
  FormikCheckbox,
  IncidentSource,
  Duration,
  TZInfo,
  FormikDateTime,
  FormikAutomation,
  FormikPrivacy
} from './FormikComponents';

type FormikFieldProps = {
  config: any,
  formikProps: any,
  hideComponent: boolean,
  hideLabel: boolean,
  label: string,
  name: string,
  type: string
};

const FormikField = (props: FormikFieldProps) => {
  const { config, formikProps, hideComponent, type } = props;
  if (hideComponent) return null;
  switch (type) {
    case 'privacy':
      return <FormikPrivacy {...props} />;
    case 'affected':
      return <Field name="affected" component={FormikTree} {...props} />;
    case 'tz-info':
      return <TZInfo {...props} />;
    case 'checkbox':
      return <FormikCheckbox {...props} />;
    case 'duration':
      return <Duration {...props} />;
    case 'datetime':
      return <FormikDateTime {...props} />;
    case 'automation':
      return <FormikAutomation {...props} />;
    case 'notification_options':
      return (
        <Flex flexDirection="column" className="notification">
          <FieldLabel
            name={config.name}
            label={config.label}
            className="label"
          />
          <Flex>
            {config.fields.map(eachField => (
              <FormikField {...eachField} {...formikProps} />
            ))}
          </Flex>
        </Flex>
      );

    case 'twitter':
      return <FormikTwitter {...props} />;
    case 'source':
      return <IncidentSource {...props} />;
    default:
      return (
        <>
          {props.hideLabel ? null : (
            <FieldLabel label={props.label} name={props.name} />
          )}
          <TextInput {...props} />
        </>
      );
  }
};

export default FormikField;
